export type PasswordRule = {
  key: string;
  test: (val: string) => boolean;
};

export const passwordRules: PasswordRule[] = [
  {
    key: 'passwordRules.lowercase',
    test: (val: string) => /[a-z]/.test(val || ''),
  },
  {
    key: 'passwordRules.uppercase',
    test: (val: string) => /[A-Z]/.test(val || ''),
  },
  {
    key: 'passwordRules.number',
    test: (val: string) => /[0-9]/.test(val || ''),
  },
  {
    key: 'passwordRules.specialChar',
    test: (val: string) => /[!@#$%^&*(),.?":{}|<>]/.test(val || ''),
  },
  {
    key: 'passwordRules.minLength',
    test: (val: string) => (val || '').length >= 8,
  },
];

export function validatePassword(value: string, minValidRules = 3): boolean {
  if (!value) return false;

  const passedRules = passwordRules.filter((rule) => rule.test(value));
  return passedRules.length >= minValidRules;
}
